import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import InfiniteScroller from 'react-infinite-scroller';

import Spinner from '@stubhub/react-spinner';

// CSS
import './index.scss';

const originalScrollListener = InfiniteScroller.prototype.scrollListener;
InfiniteScroller.prototype.scrollListener = function (...args) {
  const [e] = args;
  if (this.props.onScroll) {
    this.props.onScroll(e);
  }

  originalScrollListener.apply(this, ...args);
};

class RoyalInfiniteScroll extends PureComponent {
  constructor(props) {
    super(props);

    this.infiniteScrollerInstance = null;
  }

  componentDidUpdate(prevProps) {
    const {hasMore} = this.props;
    if (prevProps.hasMore === true && hasMore === false) {
      this.attachOnScroll();
    } else if (prevProps.hasMore === false && hasMore === true) {
      this.detachOnScroll();
    }
  }

  getParentElement = () => {
    return this.infiniteScrollerInstance.getParentElement(this.infiniteScrollerInstance.scrollComponent);
  };

  getScrollElement = () => {
    const {useWindow} = this.props;

    const parentEl = this.getParentElement();

    return useWindow ? window : parentEl;
  };

  attachOnScroll = () => {
    this.toggleScrollEventListener(true);
  };

  detachOnScroll = () => {
    this.toggleScrollEventListener(false);
  };

  toggleScrollEventListener = (on) => {
    const {onScroll} = this.props;

    const toggleMethodMap = {
      true: 'addEventListener',
      false: 'removeEventListener',
    };

    const eventListenerMethod = toggleMethodMap[on];

    if (!onScroll || on === undefined) {
      return;
    }

    const el = this.getScrollElement();

    if (el) {
      el[eventListenerMethod]('scroll', onScroll);
    }
  };

  loadMore = () => {
    const {page, loadMore} = this.props;
    loadMore(page + 1);
  };

  render() {
    const {getScrollParent, hasMore, initialLoad, loader, onScroll, pageStart, threshold, useWindow, children} =
      this.props;

    return (
      <InfiniteScroller
        getScrollParent={getScrollParent}
        hasMore={hasMore}
        initialLoad={initialLoad}
        loader={loader}
        loadMore={this.loadMore}
        onScroll={onScroll}
        pageStart={pageStart}
        threshold={threshold}
        useWindow={useWindow}
        ref={(node) => {
          this.infiniteScrollerInstance = node;
        }}
      >
        {children}
      </InfiniteScroller>
    );
  }
}

RoyalInfiniteScroll.propTypes = {
  ...InfiniteScroller.propTypes,
  page: PropTypes.number.isRequired,
  loader: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  threshold: PropTypes.number,
  useWindow: PropTypes.bool,
  initialLoad: PropTypes.bool,
  onScroll: PropTypes.func,
};

RoyalInfiniteScroll.defaultProps = {
  loader: Loader(),
  threshold: 250,
  useWindow: false,
  initialLoad: false,
};

function Loader() {
  return (
    <div
      className="RoyalInfiniteScroll__Loader"
      key="loader" /* Needed to differentiate between everything else tossed into the scroller*/
    >
      <Spinner />
    </div>
  );
}

export default RoyalInfiniteScroll;
